<template>
    <div
        :class="[
            'product-listing__side-nav js-product-listing__side-nav',
            showFilters ? 'show-filtersa' : ''
        ]"
        v-if="!preloader"
    >
        <ul class="product-listing__side-nav-container">
            <template v-for="(item, key) in categories">
                <li
                    v-if="!item.hidden"
                    :key="key"
                    class="product-listing__side-nav-item js-product-listing__side-nav-item"
                >
                    <a class="product-listing__side-nav-item-back" href="javascript:;">
                        <SvgIcon
                            class="product-listing__side-nav-item-back-arrow"
                            iconName="ico-chevron-down"
                            v-if="item.child"
                        />
                        back
                    </a>
                    <div class="product-listing__side-nav-item-img-title">
                        <div class="product-listing__side-nav-item-img">
                            <img :src="item.icon" alt="" v-if="item.icon" />
                            <div
                                class="product-listing__side-nav-item-img-ph"
                                v-else
                            >
                                <img
                                    :src="
                                        kadraGlobal.icons +
                                            '/src/assets/images/cat_placeholder.png'
                                    "
                                    alt=""
                                />
                                <span
                                    class="product-listing__side-nav-item-img-ph-title"
                                    v-if="item.name"
                                    v-html="item.name"
                                ></span>
                            </div>
                        </div>
                        <a
                            href="javascript:;"
                            class="product-listing__side-nav-item-title"
                            ><span class="" @click="checkCategory(item)">{{
                                item.name
                            }}</span>
                            <SvgIcon
                                class="product-listing__side-nav-item-arrow"
                                iconName="ico-chevron-down"
                                v-if="item.child"
                            />
                        </a>
                    </div>
                    <ul
                        v-if="item.child"
                        class="product-listing__side-nav-item-sub js-product-listing__side-nav-item-sub"
                    >
                        <li
                            v-for="term in item.child"
                            :key="term.term_id"
                            class="product-listing__side-nav-item-sub-item"
                        >
                            <a
                                href="javascript:;"
                                @click="checkCategory(term)"
                                v-html="term.name"
                            ></a>
                        </li>
                    </ul>
                </li>
            </template>
        </ul>
    </div>
</template>
<script>
import SvgIcon from '../../../base/SvgIcon/SvgIcon.vue';

export default {
    props: ['categories', 'showFilters'],
    components: {
        SvgIcon
    },
    data() {
        return {
            kadraGlobal: kadraGlobal,
            preloader: true
        };
    },
    mounted() {
        this.removePreloader();
    },
    methods: {
        checkCategory(term) {
            this.$emit('changeCategory', term);
        },
        removePreloader() {
            setTimeout(() => {
                this.preloader = false;
            }, 20);
        }
    }
};
</script>

<style lang="scss" scoped>
.product-listing__side-nav {
    z-index: 10000;
    // overflow-y: auto;
    // @include scroll-style($theme-green, transparent, 20px);
    // &::-webkit-scrollbar-track {
    // 	margin-bottom: 20px;
    // }
}
</style>
